export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  imageQuery: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'tianmei-lolita',
    name: '甜美洛丽塔',
    description: '以粉色、白色为主调，大量运用蕾丝、蝴蝶结、荷叶边等元素，打造如洋娃娃般的甜美可爱风格，是洛丽塔时尚中最受欢迎的流派之一。',
    icon: 'ri-hearts-line',
    imageQuery: 'Sweet%20Lolita%20fashion%20style%20with%20pink%20dress%20lace%20ribbons%20and%20bows%2C%20cute%20doll-like%20aesthetic%2C%20soft%20pastel%20background%2C%20elegant%20feminine%20photography%20with%20gentle%20lighting%20and%20dreamy%20atmosphere',
    articleCount: 24,
  },
  {
    slug: 'gudian-lolita',
    name: '古典洛丽塔',
    description: '融合维多利亚时代与洛可可时期的优雅元素，色彩沉稳内敛，剪裁端庄大方，展现成熟优雅的贵族气质，适合追求经典复古风格的爱好者。',
    icon: 'ri-vip-crown-line',
    imageQuery: 'Classic%20Lolita%20fashion%20with%20Victorian%20elegant%20dress%2C%20dark%20floral%20patterns%2C%20vintage%20lace%20details%2C%20sophisticated%20mature%20style%2C%20antique%20cream%20background%2C%20soft%20classical%20lighting%2C%20royal%20aesthetic',
    articleCount: 18,
  },
  {
    slug: 'gete-lolita',
    name: '哥特洛丽塔',
    description: '以黑色为主调，融入十字架、蝙蝠、蔷薇等暗黑元素，结合洛丽塔的蓬裙廓形，创造出神秘优雅又带有一丝叛逆气息的独特暗黑美学风格。',
    icon: 'ri-moon-line',
    imageQuery: 'Gothic%20Lolita%20fashion%20with%20black%20lace%20dress%2C%20dark%20elegant%20silhouette%2C%20cross%20and%20rose%20motifs%2C%20mysterious%20atmosphere%2C%20moonlit%20gothic%20cathedral%20background%2C%20dramatic%20soft%20lighting%2C%20dark%20romantic%20aesthetic',
    articleCount: 15,
  },
  {
    slug: 'zhonghuafeng-lolita',
    name: '中华风洛丽塔',
    description: '将中国传统元素与洛丽塔裙装完美结合，运用盘扣、刺绣、云肩等国风细节，搭配改良旗袍廓形与蓬裙结构，展现东西方文化交融的独特东方美学魅力。',
    icon: 'ri-china-railway-line',
    imageQuery: 'Chinese%20style%20Lolita%20fashion%20with%20traditional%20embroidery%2C%20silk%20fabric%2C%20cheongsam%20elements%2C%20elegant%20Eastern%20aesthetic%2C%20soft%20beige%20silk%20background%2C%20warm%20lantern%20lighting%2C%20cultural%20fusion%20photography',
    articleCount: 12,
  },
  {
    slug: 'chuanda-zhinan',
    name: '穿搭指南',
    description: '从基础单品搭配到完整造型方案，涵盖裙子、衬衫、裙撑、袜子、鞋履、头饰等各类单品的搭配技巧，帮助新手快速入门并提升洛丽塔穿搭品味。',
    icon: 'ri-t-shirt-line',
    imageQuery: 'Lolita%20fashion%20coordination%20guide%20with%20various%20dresses%20petticoats%20blouses%20and%20accessories%20laid%20out%20elegantly%2C%20wardrobe%20styling%20concept%2C%20soft%20cream%20vanity%20background%2C%20fashion%20editorial%20photography%20with%20natural%20light',
    articleCount: 30,
  },
  {
    slug: 'pinpai-tuijian',
    name: '品牌推荐',
    description: '盘点国内外优质洛丽塔品牌，从日系经典到国牌新秀，详细介绍各品牌的设计风格、价格定位、购买渠道，为洛丽塔爱好者提供实用的品牌选购参考。',
    icon: 'ri-store-2-line',
    imageQuery: 'Luxury%20Lolita%20brand%20boutique%20storefront%20with%20elegant%20display%20windows%2C%20beautiful%20dresses%20on%20mannequins%2C%20refined%20shopping%20atmosphere%2C%20warm%20boutique%20interior%20lighting%2C%20fashion%20retail%20photography',
    articleCount: 20,
  },
  {
    slug: 'huodong-zixun',
    name: '活动资讯',
    description: '汇集全国各地的洛丽塔茶会、走秀、主题聚会、漫展洛丽塔专区等活动信息，第一时间获取最新活动资讯，不错过每一场精彩的洛丽塔线下盛会。',
    icon: 'ri-calendar-event-line',
    imageQuery: 'Lolita%20fashion%20tea%20party%20event%20with%20elegantly%20dressed%20participants%2C%20beautiful%20venue%20decoration%20with%20flowers%20and%20lace%2C%20warm%20social%20gathering%20atmosphere%2C%20soft%20afternoon%20light%2C%20elegant%20event%20photography',
    articleCount: 16,
  },
];